
import { computed, defineComponent, onMounted, onUnmounted, ref, toRef } from "vue";
import { throttle } from "throttle-debounce";

export default defineComponent({
  name: "SliderStickyWrapper",
  props: {
    hasSlider: { type: Boolean, default: false },
    disableStickiness: { type: Boolean, default: false },
  },
  setup(props) {
    const beforeContent = ref<HTMLElement | null>(null);
    const sliderContent = ref<HTMLElement | null>(null);
    const scrollPositionY = ref<number>(0);
    const newScrollPositionY = ref<number>(0);
    const windowIsScrolled = ref<boolean>(false);
    const hasSlider = toRef(props, "hasSlider");

    const isSticky = computed(() => !props.disableStickiness && windowIsScrolled.value);
    const sliderContentSection = computed(() => sliderContent.value as HTMLElement);
    const beforeContentSection = computed(() => beforeContent.value as HTMLElement);

    onMounted(async () => {
      if (hasSlider.value) {
        const handleThrottledScroll = throttle(100, () => handleScroll());
        window.addEventListener("scroll", () => handleThrottledScroll());
      }
    });

    onUnmounted(() => {
      if (hasSlider.value) {
        window.removeEventListener("scroll", () => handleScroll());
      }
    });

    const handleScrollDirection = (): void => {
      if (hasSlider.value) {
        const lastScrollTop = scrollPositionY.value;
        scrollPositionY.value = window.scrollY;

        if (scrollPositionY.value > lastScrollTop) {
          newScrollPositionY.value = lastScrollTop;
        }
      }
    };

    const handleScroll = (): void => {
      if (hasSlider.value) {
        handleScrollDirection();
        if (sliderContent.value !== null) {
          const sliderContentRect = sliderContentSection.value.getBoundingClientRect();
          const beforeContentRect = beforeContentSection.value.getBoundingClientRect();

          if (windowIsScrolled.value === true) {
            if (
              window.innerHeight > beforeContentRect.bottom + window.innerHeight - sliderContentRect.top ||
              scrollPositionY.value < newScrollPositionY.value
            ) {
              windowIsScrolled.value = false;
            }
          } else if (windowIsScrolled.value === false && beforeContentRect.bottom > window.innerHeight) {
            if (scrollPositionY.value > sliderContentRect.top - window.innerHeight) {
              setTimeout(() => {
                windowIsScrolled.value = true;
              }, 200);
            }
          }
        }
      }
    };
    return {
      beforeContent,
      sliderContent,
      scrollPositionY,
      newScrollPositionY,
      windowIsScrolled,
      isSticky,
    };
  },
});
